module.exports = __webpack_public_path__ + "static/cctv-19f3108c62d382d4c8ac41a0967c7656.jpg";